import { onMounted, ref } from 'vue';

/**
 * Offset de safe-area do topo (px) que o header ganha no iOS.
 *
 * Espelha o CSS `.iosSafeArea` em `layouts/default.vue`:
 *   padding-top: max(env - 24px, min(env, 20px))
 *
 * O padding vive no `#divPageHeaderWrapper`, mas `headerHeight` mede so o
 * `#divPageHeader` interno — entao esse valor precisa ser somado ao
 * `headerHeight` guardado (ver `components/header/Header.vue`). Assim tudo
 * que posiciona por `topBarHeight + headerHeight` (sidebar, sticky bars,
 * modais, pull-to-refresh...) cai no lugar certo em aparelhos com
 * notch/Dynamic Island.
 *
 * Resolvido no client (le `navigator`/`env`, indisponiveis no SSR). O app e
 * portrait-lock, entao ler uma vez no mount basta.
 *
 * IMPORTANTE: manter o `- 24` em sincronia com `.iosSafeArea`.
 */
export function useIosHeaderSafeArea() {
  const { isIosDevice } = useLayout();
  const offset = ref(0);

  onMounted(() => {
    if (!isIosDevice.value) return;

    const probe = document.createElement('div');
    probe.style.cssText =
      'position:absolute;visibility:hidden;pointer-events:none;padding-top:env(safe-area-inset-top,0px);';
    document.body.appendChild(probe);
    const inset = parseFloat(getComputedStyle(probe).paddingTop) || 0;
    probe.remove();

    // max(env - 24, min(env, 20)) — ver `.iosSafeArea` em default.vue.
    offset.value = Math.max(inset - 24, Math.min(inset, 20));
  });

  return offset;
}
